import config from '../config';

export const API_PREFIX = `${config.API_BASE_URL}`;

export const APPS_ENDPOINT = `${API_PREFIX}/apps`;
export const CONFIGS_ENDPOINT = `${API_PREFIX}/configs`;
